export default __webpack_public_path__ + "static/media/jihan.170cea4b.jpg";